// Phase 43 — <FieldTintWrapper /> (Plan 43-04 Task 2).
// Thin CSS wrapper driven by useProvenance — resolves the 3-state field tint
// (tint-ai / tint-ai-edited / tint-conflict) against the canvas.css rules
// landed in Plan 43-01.

import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';
import { useProvenance } from './hooks/useProvenance';

interface FieldTintWrapperProps {
  fieldName: string;
  children: ReactNode;
  className?: string;
}

export function FieldTintWrapper({
  fieldName,
  children,
  className,
}: FieldTintWrapperProps) {
  const { state } = useProvenance(fieldName);
  return (
    <div className={cn('canvas-field', state.tintClass, className)}>
      {children}
    </div>
  );
}
